<div class="productWrap backgroundPage" fxLayout="column" id="{{ 'p_' + cartProduct.product_id }}">

    <!-- Hero Banner / Tagline -->
    <div class="hero-banner">
        <div class="hero-content">
            <div class="hero-badge">
                <mat-icon>verified</mat-icon>
                <span>{{ 'ai.professionalDigitalSignage' | transloco }}</span>
            </div>
            <h1 class="hero-title">{{ cartProduct.description }}</h1>
            <p class="hero-tagline">{{ 'ai.transformScreen' | transloco }}</p>
            <div class="hero-highlights" fxLayout="row wrap" fxLayoutGap="16px" fxLayoutAlign="center center">
                <div class="highlight-item">
                    <mat-icon>cloud_done</mat-icon>
                    <span>{{ 'ai.digitalSignage' | transloco }}</span>
                </div>
                <div class="highlight-item">
                    <mat-icon>touch_app</mat-icon>
                    <span>{{ 'ai.touchKiosk' | transloco }}</span>
                </div>
                <div class="highlight-item">
                    <mat-icon>support_agent</mat-icon>
                    <span>{{ 'ai.support247' | transloco }}</span>
                </div>
                <div class="highlight-item">
                    <mat-icon>laptop_windows</mat-icon>
                    <span>{{ 'ai.multiOS' | transloco }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Price & CTA Section -->
    <div class="cta-section" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between center" fxLayoutGap="24px">
        <div class="pricing-area" fxFlex fxLayout="column" fxLayoutAlign="center start" fxLayoutAlign.lt-md="center center">
            <div class="price-badge-large">
                <span class="price-amount">{{ cartProduct.price | StringJSV2Pipe:stringJSPipeArgs }}</span>
                <span class="price-cents">{{ 'ai.priceCents' | transloco }}</span>
            </div>
            @if (isFirstProduct) {
                <div class="value-prop">
                    <mat-icon>local_offer</mat-icon>
                    <span>{{ 'ai.freeCloudService' | transloco }}</span>
                </div>
            }
        </div>
        <div class="action-buttons" fxLayout="column" fxLayoutGap="12px">
            <button mat-raised-button color="warn" (click)="onAddCartNav(cartProduct)" class="add-cart-button modern-button pulse-button">
                <mat-icon>add_shopping_cart</mat-icon>
                <span>{{ 'ai.addToCartStart' | transloco }}</span>
            </button>
            @if (cartProduct.inAmazon) {
                <button mat-raised-button color="accent" (click)="onBuyAtAmazon($event)" class="amazon-button modern-button">
                    <mat-icon>shopping_bag</mat-icon>
                    <span>{{ 'ai.buyOnAmazon' | transloco }}</span>
                </button>
            }
            <div class="trust-indicators" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="12px">
                <div class="trust-badge">
                    <mat-icon>shield</mat-icon>
                    <span>{{ 'ai.secureCheckout' | transloco }}</span>
                </div>
                <div class="trust-badge">
                    <mat-icon>local_shipping</mat-icon>
                    <span>{{ 'ai.fastShipping' | transloco }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Modern Special Offer Section -->
    @if (cartProduct.inAmazon && onSaleActive) {
        <div class="special-offer-wrapper">
            <div class="special-offer-card">
                <div class="offer-header">
                    <mat-icon class="offer-icon">local_offer</mat-icon>
                    <h2 class="offer-headline">{{ 'ai.specialOfferSave' | transloco }}</h2>
                </div>
                <p class="offer-subtitle">{{ 'ai.buyOneGetOneFree' | transloco }}</p>
                <div class="offer-deadline">
                    <mat-icon>schedule</mat-icon>
                    <span>{{ 'ai.limitedTimeOffer' | transloco }} {{ onSaleEnd }}</span>
                </div>
                <div class="offer-steps">
                    <div class="offer-step">
                        <div class="step-number">1</div>
                        <p>{{ 'ai.amazonStep1' | transloco }}</p>
                    </div>
                    <div class="offer-step">
                        <div class="step-number">2</div>
                        <p>{{ 'ai.amazonStep2' | transloco }}</p>
                    </div>
                    <div class="offer-step">
                        <div class="step-number">3</div>
                        <p>{{ 'ai.amazonStep3' | transloco }}</p>
                    </div>
                    <div class="offer-step">
                        <div class="step-number">4</div>
                        <p>{{ 'ai.amazonStep4' | transloco }}</p>
                    </div>
                    <div class="offer-step">
                        <div class="step-number">5</div>
                        <p>{{ 'ai.amazonStep5' | transloco }}</p>
                    </div>
                </div>
            </div>
        </div>
    }

    <!-- Modern Content Section -->
    <div class="product-content" fxLayout="row" fxLayout.lt-md="column-reverse" fxLayoutGap="40px" fxLayoutGap.lt-md="20px">
        <div class="description-section" fxFlex>
            <div class="description-card">
                <h3 class="section-title">
                    <mat-icon>auto_awesome</mat-icon>
                    {{ 'ai.whatMakesThisSpecial' | transloco }}
                </h3>
                <p class="description-text description-enhanced">
                    {{ cartProduct.long_description }}
                </p>
                <div class="description-callout">
                    <mat-icon>info</mat-icon>
                    <div class="callout-content">
                        <strong>{{ 'ai.perfectFor' | transloco }}</strong> {{ 'ai.perfectForDescription' | transloco }}
                    </div>
                </div>
            </div>
        </div>

        <!-- Image Gallery Section (Main + Thumbnails) -->
        <div class="image-gallery-wrapper" fxFlex="240px" fxFlex.lt-md="100%">
            <div class="main-image-container" (click)="onImageSelected(cartProduct)">
                <img [src]="productImages + cartProduct.image"
                     [alt]="cartProduct.description"
                     class="main-image"/>
                <div class="image-overlay">
                    <mat-icon>zoom_in</mat-icon>
                    <span>{{ 'ai.clickToEnlarge' | transloco }}</span>
                </div>
            </div>
            <div class="image-caption">
                <mat-icon>touch_app</mat-icon>
                <span>{{ 'ai.clickToViewFullSize' | transloco }}</span>
            </div>

            <!-- Thumbnail Gallery -->
            <div class="thumbnail-gallery-compact">
                <div class="thumbnail-wrapper-compact" [class.active]="selectedThumbIndex === 0" (click)="onImageSelected(cartProduct); setSelectedThumb(0)">
                    <img [src]="productImages + cartProduct.image" [alt]="cartProduct.description" class="thumbnail-image"/>
                </div>
                <div class="thumbnail-wrapper-compact" [class.active]="selectedThumbIndex === 1" (click)="onThumbSelected(cartProduct, 1); setSelectedThumb(1)">
                    <img [src]="productImages + cartProduct.image_thumb_1" [alt]="cartProduct.description" class="thumbnail-image"/>
                </div>
                <div class="thumbnail-wrapper-compact" [class.active]="selectedThumbIndex === 2" (click)="onThumbSelected(cartProduct, 2); setSelectedThumb(2)">
                    <img [src]="productImages + cartProduct.image_thumb_2" [alt]="cartProduct.description" class="thumbnail-image"/>
                </div>
                <div class="thumbnail-wrapper-compact" [class.active]="selectedThumbIndex === 3" (click)="onThumbSelected(cartProduct, 3); setSelectedThumb(3)">
                    <img [src]="productImages + cartProduct.image_thumb_3" [alt]="cartProduct.description" class="thumbnail-image"/>
                </div>
                @if (cartProduct.product_id == ADZ) {
                    <div class="thumbnail-wrapper-compact" [class.active]="selectedThumbIndex === 4" (click)="onThumbSelected(cartProduct, 4); setSelectedThumb(4)">
                        <img [src]="productImages + cartProduct.image_thumb_4" [alt]="cartProduct.description" class="thumbnail-image"/>
                    </div>
                    <div class="thumbnail-wrapper-compact" [class.active]="selectedThumbIndex === 5" (click)="onThumbSelected(cartProduct, 5); setSelectedThumb(5)">
                        <img [src]="productImages + cartProduct.image_thumb_5" [alt]="cartProduct.description" class="thumbnail-image"/>
                    </div>
                    <div class="thumbnail-wrapper-compact" [class.active]="selectedThumbIndex === 6" (click)="onThumbSelected(cartProduct, 6); setSelectedThumb(6)">
                        <img [src]="productImages + cartProduct.image_thumb_6" [alt]="cartProduct.description" class="thumbnail-image"/>
                    </div>
                    <div class="thumbnail-wrapper-compact" [class.active]="selectedThumbIndex === 7" (click)="onThumbSelected(cartProduct, 7); setSelectedThumb(7)">
                        <img [src]="productImages + cartProduct.image_thumb_7" [alt]="cartProduct.description" class="thumbnail-image"/>
                    </div>
                    <div class="thumbnail-wrapper-compact" [class.active]="selectedThumbIndex === 8" (click)="onThumbSelected(cartProduct, 8); setSelectedThumb(8)">
                        <img [src]="productImages + cartProduct.image_thumb_8" [alt]="cartProduct.description" class="thumbnail-image"/>
                    </div>
                }
            </div>
        </div>
    </div>

    <!-- Modern Features Section -->
    <div class="features-section">
        <div class="features-card">
            <h3 class="section-title">
                <mat-icon>stars</mat-icon>
                {{ 'ai.whatsIncluded' | transloco }}
            </h3>
            <p class="features-intro">{{ 'ai.everythingYouNeed' | transloco }}</p>
            <div class="features-list">
                @for (bullet of cartProduct.bullets.split('| '); track bullet) {
                    <div class="feature-item">
                        <mat-icon class="feature-icon">check_circle</mat-icon>
                        <span class="feature-text">{{ bullet }}</span>
                    </div>
                }
            </div>
        </div>
    </div>

</div>
<ng-template let-modal #thumbDialogModal>
    <div class="section-header" mat-dialog-title>
        <mat-icon class="section-icon">image</mat-icon>
        <span class="section-title">{{ 'ai.productImage' | transloco }}</span>
        <button mat-icon-button class="close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div mat-dialog-content class="dialog-content">
        <div class="modal-image-container">
            <img [src]="productImages + selectedThumb" [alt]="cartProduct.description" class="modal-image"/>
        </div>
    </div>
</ng-template>


